<template>
    <div class="card">
            <div class="card-body">
                <div v-if="loading">
                    Loading ...
                </div>
                <div v-else>
                    <div v-if="error != null">{{error}}</div>
                    <div v-if="allLocationData != null">
                        <v-container class="chart-container">
                        <Bar 
                            :options="mergedChartOptions"
                            :data="allLocationData" />
                        </v-container>
                    </div>
                </div>
            </div>
          </div>
  </template>
  
  <script>

  import { Bar } from 'vue-chartjs'
  import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale } from 'chart.js'
  ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
  
  export default {
    name: 'SolarLocationsMerged',
    components: {
        Bar
    },
    props: ['locations', 'chartOptions'],
    data() {
      return {
        allLocationData: null,
        loading: true,
        error: null,
        mergedChartOptions: {
            responsive: true,
            maintainAspectRatio: false,
            scales: {
                y: {
                    max: 100000,
                    title: {
                        text: "Wh",
                        display: true
                    }
                }
            },
            plugins: {
                title: {
                    display: true,
                    text: "All Locations - Last 7 Days",
                    font: {
                        size: 24
                    }
                }
            }
        },
      };
    },
    async mounted() {
      //this.fetchNoteDetails();
      this.organizeData();
    },    
    methods: {
        organizeData() {
            try {
                this.error = null;
                let chartData = {
                    labels: [],
                    datasets: []
                };

                for(let i = 0; i < this.locations.length; i++) {
                    let location = this.locations[i];
                    if(location.dailyValues == null) {
                        throw("ERROR: daily values for " + location.solarId + " is null");
                    }
                    let data = [];

                    let dataSet = {
                        //label: location.solarId,
                        label: location.friendlyName,
                        //backgroundColor: this.randomColorGenerator(),
                        backgroundColor: location.color,
                        //backgroundColor: '#f87979',
                        //backgroundColor: ["red", "blue", "green", "blue", "red", "blue"], 
                        data: data
                    };
                    chartData.datasets.push(dataSet);

                    let days = 7;
                    let end = 0;
                    if(days > 0 && location.dailyValues.length > days) {
                        end = location.dailyValues.length - days;
                    }
                    for(let j = location.dailyValues.length - 1; j >= end; j--) {
                        let dv = location.dailyValues[j];
                    
                        if(i == 0) {
                            chartData.labels.unshift(dv.prettyDate);
                        }
                        data.unshift(dv.production)
                    }
                }
                this.allLocationData = chartData;
            }
            catch(e) {
                this.error = e;
            }
            finally {
                this.loading = false;
            }

        },

        randomColorGenerator()  { 
            return '#' + (Math.random().toString(16) + '0000000').slice(2, 8); 
        }
    }
  };
  </script>
  
  <style scoped>  
  .card {
    /*
    cursor: pointer;
    */
  }

  .chart-container {
  flex-grow: 1;
  /*min-height: 0;*/
  min-height: 400px;

  > div {
    position: relative;
    height: 100%;
  }
}
  </style>